export const magicOTPRoute = {
  path: '/account-verification',
  name: 'account-verification',
  component: () => import(/* webpackChunkName: "MagicEmail" */ '../../views/MagicOTPForm.vue'),
  meta: { publicRoute: true },
}
